/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Clay } from "..";
import { dotSizeVariant, dotTypeVariant, sizeVariant, typeVariant } from "./Badge.css";
import type { BadgeDotProp, BadgeProps } from "./Badge.types";

/**
 * @deprecated `Badge` 컴포넌트는 더 이상 사용되지 않습니다. `Badge` 컴포넌트 대신 `NumberBadge` / `DotBadge` 컴포넌트를 사용해주세요.
 */
export const Badge = ({
  text,
  type,
  on = false,
  size = "default",
  state = "default",
  ...restProps
}: BadgeProps) => {
  return (
    <Clay
      display="inline-block"
      borderRadius={vars.rounded.full}
      native={{
        "data-clay-badge-on": on,
        "data-clay-badge-state": state,
      }}
      height="fit-content"
      width="fit-content"
      transition="all 0.3s ease-out"
      css={[sizeVariant[size], typeVariant[type]]}
      {...restProps}
    >
      {text}
    </Clay>
  );
};

const BadgeDot = ({ size, type, sx }: BadgeDotProp) => (
  <Clay
    css={[
      {
        outlineColor: "white",
        borderRadius: "50%",
        outlineStyle: "solid",
      },
      dotTypeVariant[type],
      dotSizeVariant[size],
      sx,
    ]}
  />
);

Badge.Dot = BadgeDot;
